import axios from './index'

export function getMessageList() {
  return axios.get('/message/list')
}
